import { useMemo } from 'react';
import { useCurrentUser } from '@/contexts';
import { resolveViewerLocation, type ViewerLocation } from '@/utils/geo';

/**
 * The position the viewer browses from. For admins with a saved
 * `locationOverride` this is the override; for everyone else it is the
 * public profile location. `locationEnabled` reports whether
 * distance-based discovery applies (an override implies it).
 */
export function useViewerLocation(): ViewerLocation {
  const { currentUser, settings, isAdmin } = useCurrentUser();
  return useMemo(
    () => resolveViewerLocation(currentUser, settings, isAdmin),
    [currentUser, settings, isAdmin]
  );
}
